import React from 'react'
import List from '../../components/List'
import { connect } from 'react-redux'
import {
    Chip,
    FormControlLabel,
    Switch,
    TextField,
    withStyles,
} from '@material-ui/core'
import Page from '../../components/Page'
import { Icon } from '@material-ui/core'

import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@material-ui/core'
import {
    fileDataFormAddModelEdit,
    fileDataFormAddSkuEdit,
    fileDataFormRemoveModelEdit,
    fileDataFormRemoveSkuEdit,
    fileDataFormToggleActive,
    fileDataFormDelete,
    getAssetTypes,
    getProductAssets,
    updateFileData,
    updateFileDataFormEdit,
} from '../../actions/UploadActions'
import { SingleSelect } from '../../components/Select'
import IconButton from '../../components/IconButton'
import Input from '../../components/Input'
import CreateProductAssetModal from '../product/components/ProductAssetModal'

const styles = theme => ({
    iconButton: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
    },
})

const sleep = ms => new Promise(r => setTimeout(r, ms))

class FileDataForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            sku: '',
            model: '',
        }
    }

    setLabel = label =>
        this.props.updateFileDataForm(this.props.item.id, { label })
    setBrand = brand =>
        this.props.updateFileDataForm(this.props.item.id, { brand })
    setAssetType = value => {
        this.props.updateFileDataForm(this.props.item.id, { assetType: value })
    }
    addSku = sku => {
        this.props.fileDataFormAddSku(this.props.item.id, sku)
        this.setState({ sku: '' })
    }
    addModel = model => {
        this.props.fileDataFormAddModel(this.props.item.id, model)
        this.setState({ model: '' })
    }
    removeSku = sku => this.props.fileDataFormRemoveSku(this.props.item.id, sku)
    removeModel = model =>
        this.props.fileDataFormRemoveModel(this.props.item.id, model)
    setSku = sku => this.setState({ sku })
    setModel = model => this.setState({ model })
    toggleActive = () => this.props.fileDataFormToggleActive(this.props.item.id)

    onSubmit = () => {
        const {
            label,
            brand,
            skus,
            models,
            assetType,
            url,
            id,
            active,
        } = this.props.item

        this.props.saveFileData(id, {
            label,
            brand,
            skus,
            models,
            url,
            assetType: assetType.value,
            active,
        })
    }

    render() {
        const { sku, model } = this.state
        const {
            label,
            brand,
            assetType,
            skus,
            models,
            active,
        } = this.props.item
        const { classes } = this.props

        const {
            setLabel,
            setBrand,
            addSku,
            addModel,
            removeSku,
            removeModel,
            setAssetType,
            setSku,
            setModel,
            toggleActive,
        } = this
        const { items: assetTypes, loading } = this.props.assetTypes

        let assetTypesOptions = []

        for (const [value, label] of Object.entries(assetTypes)) {
            assetTypesOptions.push({ value: String(value), label })
        }

        let fileType = null

        if (assetType != null && assetTypes[String(assetType.value)] != null) {
            fileType = {
                label: assetTypes[String(assetType.value)],
                value: assetType,
            }
        }

        const skusChips = skus.map(s => {
            return <Chip key={s} label={s} onDelete={() => removeSku(s)} />
        })

        const modelChips = models.map(m => {
            return <Chip key={m} label={m} onDelete={() => removeModel(m)} />
        })

        return (
            <>
                {loading ? (
                    <p>Ładuje</p>
                ) : (
                    <>
                        <div className="flex">
                            <SingleSelect
                                className="mt-8 mr-8 mb-16"
                                label="Rodzaj pliku"
                                id="file-form-type"
                                name="assetType"
                                value={fileType}
                                onChange={setAssetType}
                                options={assetTypesOptions}
                                fullWidth
                            />
                        </div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Nazwa pliku (wyświetlana użytkownikowi)"
                                id="file-form-label"
                                name="label"
                                value={label}
                                onChange={e => setLabel(e.target.value)}
                                variant="outlined"
                                fullWidth
                            />
                        </div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Marka"
                                id="file-form-brand"
                                name="brand"
                                value={brand}
                                onChange={e => setBrand(e.target.value)}
                                variant="outlined"
                                fullWidth
                            />
                        </div>
                        <div
                            className="flex"
                            style={{ flexWrap: 'wrap', gap: '8px' }}
                        >
                            {skusChips}
                        </div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Sku"
                                id="file-form-sku"
                                name="sku"
                                value={sku}
                                onChange={e => setSku(e.target.value)}
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        addSku(sku)
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                            />
                            <IconButton
                                className={classes.iconButton}
                                icon="add"
                                onClick={() => addSku(sku)}
                            />
                        </div>
                        <div
                            className="flex"
                            style={{ flexWrap: 'wrap', gap: '8px' }}
                        >
                            {modelChips}
                        </div>
                        <div className="flex">
                            <Input
                                className="mt-8 mb-16 mr-8"
                                required
                                label="Model"
                                id="file-form-model"
                                name="model"
                                value={model}
                                onChange={e => setModel(e.target.value)}
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        addModel(model)
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                            />
                            <IconButton
                                className={classes.iconButton}
                                icon="add"
                                onClick={() => addModel(model)}
                            />
                        </div>
                        <div className="flex">
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={!active}
                                        color="primary"
                                        onChange={toggleActive}
                                    />
                                }
                                label={'Do usunięcia'}
                            />
                        </div>
                        <div className="flex">
                            <IconButton
                                className="mt-8"
                                icon="save"
                                onClick={this.onSubmit}
                            >
                                Zapisz
                            </IconButton>
                        </div>
                    </>
                )}
            </>
        )
    }
}

const FileDataFormWithStyles = connect(({ presto }) => {}, {
    saveFileData: updateFileData,
    updateFileDataForm: updateFileDataFormEdit,
    fileDataFormAddSku: fileDataFormAddSkuEdit,
    fileDataFormAddModel: fileDataFormAddModelEdit,
    fileDataFormRemoveSku: fileDataFormRemoveSkuEdit,
    fileDataFormRemoveModel: fileDataFormRemoveModelEdit,
    fileDataFormToggleActive: fileDataFormToggleActive,
})(withStyles(styles)(FileDataForm))

class ProductAssetModal extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <>
                <Dialog
                    onClose={this.props.onClose}
                    open={this.props.open}
                    fullWidth
                >
                    <DialogTitle>Upload</DialogTitle>
                    <DialogContent>
                        {this.props.data != null ? (
                            <FileDataFormWithStyles
                                item={this.props.data}
                                assetTypes={this.props.assetTypes}
                            />
                        ) : (
                            ''
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.props.onClose}
                            variant="contained"
                            color="secondary"
                        >
                            Zamknij
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

class ActionMenu extends React.Component {
    state = {
        anchorEl: null,
    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ anchorEl: null })
    }

    render() {
        const { anchorEl } = this.state

        return (
            <div>
                <Button
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    <Icon className="text-32">more_horiz</Icon>
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                >
                    <MenuItem
                        onClick={() => {
                            this.props.onEdit()
                            this.handleClose()
                        }}
                    >
                        Edytuj
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            window.open(this.props.url)
                            this.handleClose()
                        }}
                    >
                        Podgląd pliku
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            this.props.onDelete()
                            this.handleClose()
                        }}
                    >
                        Usuń
                    </MenuItem>
                </Menu>
            </div>
        )
    }
}

class Downloads extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            editing: null,
            query: '',
        }
    }

    componentDidMount() {
        this.props.getProductAssets()
        this.props.getAssetTypes()
    }

    edit = id => {
        this.setState({ editing: id })
    }

    render() {
        const columns = [
            { name: 'Rodzaj pliku' },
            { name: 'Skus' },
            { name: 'Modele' },
            { name: 'Marka' },
            { name: 'Nazwa' },
            { name: 'Url' },
            { name: 'Wyświetlany' },
        ]

        const values = Object.values(this.props.items).map(item => {
            return {
                actions: [
                    <ActionMenu
                        key={item.id}
                        url={item.url}
                        onEdit={() => {
                            this.edit(item.id)
                        }}
                        onDelete={() => {
                            let input = {
                                ...item,
                                active: false,
                                assetType: item.assetType.value,
                            }

                            this.props.delete(item.id, input)
                        }}
                    />,
                ],
                columns: [
                    item.assetType.name,
                    item.skus.join(', '),
                    item.models.join(', '),
                    item.brand,
                    item.label,
                    item.url,
                    item.active ? ' Tak ' : ' Nie ',
                ],
            }
        })

        const itemForEdit = this.props.items[this.state.editing]

        return (
            <Page
                pageTitle="Pliki do pobrania"
                headerIcon={
                    <Icon className="text-32 mr-0 sm:mr-12">
                        cloud_download
                    </Icon>
                }
                content={
                    <>
                        <div className="mb-32">
                            <TextField
                                fullWidth
                                placeholder="Szukaj..."
                                label={'Wyszukiwanie'}
                                name="query"
                                value={this.state.query}
                                onChange={e =>
                                    this.setState({ query: e.target.value })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        this.props.getProductAssets(
                                            1,
                                            this.props.pageSize,
                                            this.state.query
                                        )
                                    }
                                }}
                                type="text"
                                InputProps={{
                                    endAdornment: <Icon>search</Icon>,
                                }}
                            />
                        </div>
                        <div className="mb-32">
                            <CreateProductAssetModal
                                onUpload={() => {
                                    sleep(1000).then(() => {
                                        this.props.getProductAssets()
                                    })
                                }}
                            />
                        </div>
                        <List
                            loading={this.props.loading}
                            columns={columns}
                            values={values}
                            onSearch={data => {
                                this.props.getProductAssets(
                                    1,
                                    this.props.pageSize,
                                    data
                                )
                            }}
                            paginated
                            onChangePage={(event, page) => {
                                page += 1
                                this.props.getProductAssets(
                                    page,
                                    this.props.pageSize,
                                    this.props.query
                                )
                            }}
                            onChangeRowsPerPage={event =>
                                this.props.getProductAssets(
                                    this.props.page,
                                    event.target.value,
                                    this.props.query
                                )
                            }
                            count={this.props.total}
                            page={this.props.page - 1}
                            rowsPerPage={this.props.pageSize}
                        />
                        <ProductAssetModal
                            data={itemForEdit}
                            assetTypes={this.props.assetTypes}
                            onClose={() => this.setState({ editing: null })}
                            open={
                                this.state.editing != null &&
                                this.state.editing != undefined
                            }
                        />
                    </>
                }
            />
        )
    }
}

const mapStateToProps = ({ presto }) => {
    const { productAssetTypes } = presto
    return {
        items: presto.productAssets.items,
        page: presto.productAssets.page,
        pageSize: presto.productAssets.pageSize,
        loading: presto.productAssets.loading,
        assetTypes: productAssetTypes,
        total: presto.productAssets.total,
        query: presto.productAssets.query,
    }
}

export default connect(mapStateToProps, {
    delete: fileDataFormDelete,
    getProductAssets,
    getAssetTypes,
})(withStyles(styles, { withTheme: true })(Downloads))
